import React, { useEffect, useState } from 'react';
import { TileLayout } from "@progress/kendo-react-layout";
import { useLocation } from 'react-router-dom';
import { guid } from '@progress/kendo-react-common';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import Spinner from '../Spinner/Spinner';
import commonPageService from '../../../../shared/common-utilities/services/commonPageService';

let apiService = commonApiService();
let commonService = commonPageService();

const _guid = guid();
const CustomViewTemplate = () => {

  const location = useLocation()
  const [currentCustomView, setCurrentCustomView] = useState();
  const [column, setColumn] = useState(0);
  const [tiles, setTiles] = useState([]);
  const [tileKey, setTileKey] = useState(0);

  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    sendApi();
  }, [location?.state?.data])

  useEffect(() => {
    setTiles([]);
    if (currentCustomView) {
      const positionSet = currentCustomView[0]?.Tiles.map((item, index) => {
        return { ...item.defaultPosition, order: index }
      });
      const tempPosition = currentCustomView[0].place;
      setColumn(currentCustomView[0].column);

      if (tempPosition != undefined) {
        setTilesAndKey(tempPosition, currentCustomView);
      } else {
        setTilesAndKey(positionSet, currentCustomView);
      }
    }
  }, [currentCustomView])

  const setTilesAndKey = (tilePosition, customView) => {
    if (tilePosition) {
      const tmpId = guid()
      const tempTiles = [tilePosition.map((item, index) =>
        ({
          guid : tmpId,
          title: customView[0].subGrids[index],
          defaultPosition: item,
          hidden: false,
          item: (commonService.mapPages(customView[0].subGrids[index], customView[0].mainGrid != customView[0].subGrids[index], customView[0].Tiles[index]?.isPin, tmpId, false)),
          resizable: false,
          reorderable: false,
          isPin: customView[0].Tiles[index].isPin,
          className: (customView[0].mainGrid == customView[0].subGrids[index] ? "mainGridTile" : "subGridTile")
        })
      )]
      setTiles(tempTiles);
      setTileKey(tileKey + 1);
    }
  }

  const sendApi = () => {
    const customView = location?.state?.data;
    setIsLoading(true);
    if(customView){
      apiService.get(customView["userMetadata@odata.mediaReadLink"],null,null,null,null, customView["@odata.etag"]).then(response => {
        setCurrentCustomView(response);
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)}

      <TileLayout style={{ width: '100%' }}
        key={tileKey}
        columns={4}
        //rowHeight={355}
        className='tile-fix-height'
        gap={{
          rows: 5,
          columns: 5,
        }}
        items={tiles[0]}
      />
    </>
  )
}

export default CustomViewTemplate;